import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';

export const templateExportExclusionsPanel = document.createElement('template');

templateExportExclusionsPanel.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="export-wrapper">
    <div class='content-wrapper'>
      <gz-text fontSize="14" id="export-exclusions-message" class="mb-5"></gz-text>

      <div style="display:none;">
      <gz-title class='form-subtitle' id='export-column-mapping-title'></gz-title>

        <gz-form-field id='export-object-type-form-field' class='label-mw-250' label=''>
            <gz-input gz-form-input placeholder='' inputWidth="240"></gz-input>
            <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id='export-excluded-item-form-field' class='label-mw-250' label=''>
          <gz-input gz-form-input placeholder='' inputWidth="240"></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id='export-exclusion-modules-form-field' class='label-mw-250' label=''>
          <gz-input gz-form-input placeholder='' inputWidth="240"></gz-input>
          <gz-input-error></gz-input-error>
      </gz-form-field>
      </div>

      <gz-title class='form-subtitle mb-3' id='export-data-preview-title'></gz-title>

      <gz-table id='export-exclusions-data-preview' classicTableStyle></gz-table>

      <div class='bottom-buttons'>
          <gz-button id='save-button' ></gz-button>
          <gz-button type='outline' color='secondary' id='cancel-button'></gz-button>
      </div>
    </div>
  </div>
 `;
